export class ReportCandidateDTO {
  constructor({ candidateId, demandId, reasonId, comment } = {}) {
    this.candidateId = candidateId;
    this.demandId = demandId;
    this.reasonId = reasonId;
    this.comment = comment;
  }

  prepareReportCandidateData() {
    return {
      candidateId: this.candidateId,
      demandId: this.demandId,
      reasonId: this.reasonId,
      comment: this.comment !== "" ? this.comment : undefined,
    };
  }
}
